import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Backdrop from "./Backdrop";
import httpService from "../services/httpService";
import ApplicantSidebar from "./ApplicantSidebar";
import AppHeader from "./AppHeader";

const LayoutContent: React.FC = () => {
    const { isExpanded, isHovered, isMobileOpen } = useSidebar();

    return (
        <div className="max-w-7xl mx-auto py-6 dark:bg-gray-900 lg:flex">
            <ApplicantSidebar />
            <Backdrop />

            <div
                className={`flex-1 transition-all duration-300 ease-in-out `}
            >
                <Outlet />
            </div>
        </div>
    );
};

// --- FIX 3: Accept an onLogout prop ---
const ApplicantLayout: React.FC<{ onLogout: () => void }> = ({ onLogout }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState<any>(() => {
        const cachedUser = localStorage.getItem("user");
        return cachedUser ? JSON.parse(cachedUser) : null;
    });

    useEffect(() => {
        const fetchUser = async () => {
            // If user is already in state from localStorage, no need to fetch
            if (user) {
                setLoading(false);
                return;
            }

            try {
                // This runs if user was not in localStorage
                const response: any = await httpService.get("/user/me");
                setUser(response[0]);
                localStorage.setItem("user", JSON.stringify(response[0]));
            } catch (err) {
                // If token is invalid or expired, the API call will fail.
                // Call the logout handler passed from App.js
                onLogout();
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
        // --- FIX 4: Remove 'user' from the dependency array ---
        // This prevents the effect from re-running after setUser is called.
    }, [navigate, onLogout]); // Added onLogout to dependencies


    if (loading) {
        return (
            <div className="w-full h-screen flex items-center justify-center bg-gray-900 text-white">
                <p>Checking authentication...</p>
            </div>
        );
    }

    return (
        <SidebarProvider>
            {/* You can pass onLogout down to LayoutContent if needed */}
            <LayoutContent />
        </SidebarProvider>
    );
};

export default ApplicantLayout;
